export default __webpack_public_path__ + "static/media/person.76771ab3.svg";